import { Controller } from "@hotwired/stimulus"
import { trackEvent } from "../analytics"

// Reports `application.form_started` the first time the prospect puts content
// into the advocate-application (join) form. This is the intermediate funnel
// signal between viewing the join form and submitting it — there's no server
// round-trip before submit, so it can only be captured client-side. Fires on
// the first `input` (typing in any field), deduped per session so the
// rate-limited ingestion endpoint isn't spammed across Turbo re-renders.
//
// Example usage:
//   <form data-controller="application-form-started"
//         data-action="input->application-form-started#start"> … </form>
export default class extends Controller {
  start() {
    if (this.fired) return
    this.fired = true

    if (this.alreadyReported()) return
    this.markReported()

    trackEvent("application.form_started")
  }

  storageKey() {
    return "application-form-started"
  }

  alreadyReported() {
    try {
      return sessionStorage.getItem(this.storageKey()) === "1"
    } catch {
      return false
    }
  }

  markReported() {
    try {
      sessionStorage.setItem(this.storageKey(), "1")
    } catch {
      // sessionStorage unavailable (private mode quota) — fall back to the
      // per-connect this.fired guard.
    }
  }
}
